import React from "react";

// Một số font tùy biến (vd AmpleSoftPro cho tiêu đề) KHÔNG render ký tự
// non-breaking space (U+00A0) nên hai chữ nối bằng nbsp bị dính vào nhau.
// Trong dữ liệu (dichVuVanHanh.json) mình dùng nbsp làm "dấu đánh nhóm không
// xuống dòng". Helper này render các cụm đó thành <span nowrap> nhưng thay
// nbsp bằng DẤU CÁCH THƯỜNG: vừa hiển thị đúng khoảng cách, vừa không ngắt dòng.
const NBSP = " ";

export default function renderNoBreak(text) {
  if (!text || typeof text !== "string" || !text.includes(NBSP)) {
    return text;
  }
  const out = [];
  // Tách theo dấu cách THƯỜNG; token nào còn chứa nbsp là 1 cụm cần giữ liền.
  text.split(" ").forEach((tok, i) => {
    if (i > 0) out.push(" ");
    if (tok.includes(NBSP)) {
      out.push(
        <span
          key={i}
          style={{ whiteSpace: "nowrap", color: "inherit", font: "inherit", letterSpacing: "inherit" }}
        >
          {tok.split(NBSP).join(" ")}
        </span>
      );
    } else {
      out.push(tok);
    }
  });
  return out;
}
